const remoteMessages = {
  'remote.incoming.alert.button.reject': '拒否',
  'remote.incoming.alert.button.answer': '応答',
  'remote.incoming.alert.message': '{name}から着信があります',
  'remote.incoming.alert.message.nameUnknown': '着信があります',
  'remoteInfo.waiting.title': '待機中...',
  'remoteMenuPage.CallToOperators.title': '全オペレータ依頼',
  'remoteMenuPage.noLicense.CallToOperators.message':
    'ユーザの遠隔支援ライセンスが無効です',
  'remotePage.waiting.title': '待機中...',
  'remotePage.supportEnd.title': '接続有効期限：',
  'remotePage.deviceName.web': 'Web接続',
  'remotePage.message.disconnectMessage.1301':
    '["他の遠隔作業支援に参加しているため接続できません"]',
  'remotePage.message.disconnectMessage.1303':
    '["遠隔作業支援ライセンスがありません"]',
  'remotePage.message.disconnectMessage.1304':
    '["遠隔作業支援ライセンス数の上限を超過しています"]',
  'remotePage.message.disconnectMessage.1309': '["通話が終了しました"]',
  'remotePage.message.somthingError':
    '["エラーが発生しました","[code: {errorCode}]"]',
  'remotePage.message.denied': '{name}に着信拒否されました',
  'remotePage.message.deviceNotReady': 'デバイスの準備ができていません',
  'remotePage.message.deviceNotReady.1': 'マイクまたはカメラに接続できません',
  'remotePage.message.deviceNotReady.2': 'マイクに接続できません',
  'remotePage.message.RoomEmpty':
    '他のユーザが退室済みもしくは着信を拒否したため、通話を終了します',
  'remotePage.message.RequestTimeout': '通話が終了しました',
  'remotePage.members.status.1': '呼出中…',
  'remotePage.members.status.2': '呼出中…',
  'remotePage.members.status.3': '参加中',
  'remotePage.members.status.4': '退出',
  'remotePage.members.status.99': '拒否',
  'remotePage.members.button.call': '再通知',
  'remotePage.button.members': '参加者 {count}人',
  'remotePage.button.endOfSupport': '支援終了',
  'remotePage.button.wait': '復旧',
  'remotePage.button.clearScreen': '画面クリア',
  'remotePage.button.label.pointer': '指差し',
  'remotePage.button.label.pen': '色ペン',
  'remotePage.button.label.remote': '遠隔操作',
  'remotePage.button.label.sendText': '黒板設定',
  'remotePage.button.label.video': '映像のみ',
  'remotePage.button.label.mic': 'マイク',
  'remotePage.button.label.zoom': 'ズーム',
  'remotePage.button.label.zoom.expand': '拡大',
  'remotePage.button.label.zoom.contract': '縮小',
  'remotePage.button.label.zoom.reset': 'リセット',
  'remotePage.button.label.light': 'ライト',
  'remotePage.button.label.chat': 'チャット',
  'remotePage.button.label.pause': '一時停止',
  'remotePage.button.label.photo': '撮影',
  'remotePage.bs.label.title': '黒板設定',
  'remotePage.bs.label.design': '外観',
  'remotePage.bs.label.design.showHide': '表示 / 非表示',
  'remotePage.bs.label.design.showHide.show': '表示',
  'remotePage.bs.label.design.showHide.hide': '非表示',
  'remotePage.bs.label.design.bgColor': '背景色',
  'remotePage.bs.label.design.opacity': '不透明度',
  'remotePage.bs.label.design.bgColors': {
    green: '緑',
    red: '赤',
    blue: '青',
    black: '黒',
  },
  'remotePage.bs.label.design.opacity.value': '{opacity} %',
  'remotePage.bs.label.design.position': '位置',
  'remotePage.bs.label.design.positions': {
    left_top: '左上',
    right_top: '右上',
    left: '左',
    right: '右',
    left_bottom: '左下',
    right_bottom: '右下',
  },
  'remotePage.bs.label.letters': '記載内容',
  'remotePage.bs.label.letters.msg':
    '内容入力し送信を押してください。保存することで内容を再利用できます。',
  'remotePage.bs.label.letters.title': '工事名',
  'remotePage.bs.label.letters.suffixes': {
    none: '',
    private: '様',
    privateResidence: '様邸',
    constructionSite: '現場',
  },
  'remotePage.bs.label.letters.subTitle': '工種',
  'remotePage.bs.label.letters.suffix': '接尾語',
  'remotePage.bs.label.letters.remarks': '備考',
  'remotePage.bs.label.letters.save': '保存',
  'remotePage.bs.toast.letters.save': '黒板記載内容を保存しました',
  'remotePage.bs.toast.letters.send': '黒板記載内容を送信しました',
  'remotePage.bs.input.error.overTotalWordCount':
    '{max}文字以下で入力してください',
  'callingRoomsDialog.button.join': '参加',
};

export default remoteMessages;
